import { permissionMatches, Permission } from '@pmp/contexts';
import { CheckPermissionsOptions, CheckFlagOptions } from '@pmp/types';

export const checkPermissions = ({
  permissions = [],
  userPermissions = new Set<Permission>(),
  permissionsOperator = 'AND',
}: CheckPermissionsOptions): boolean => {
  if (!permissions?.length) return true;

  return permissionsOperator === 'AND'
    ? permissions.every(neededPermission => permissionMatches(userPermissions, neededPermission))
    : permissions.some(neededPermission => permissionMatches(userPermissions, neededPermission));
};

export const checkFlags = ({ flags = [], envFeatureFlags = new Set(), flagsOperator = 'AND' }: CheckFlagOptions): boolean => {
  if (!flags.length) return true;

  return flagsOperator === 'AND' ? flags.every(f => envFeatureFlags.has(f)) : flags.some(f => envFeatureFlags.has(f));
};
